class ValidationMessage {
  static checkRequired = "Required.";
  static checkLength = "Length Exceeded.";
  static checkValidEmail = "Please enter valid email.";
  static checkValidPhone = "Please enter valid phone.";
}

export default ValidationMessage;
